import { z } from "@reflag/shared/utils/zod";

export const nameSchema = z
  .string()
  .trim()
  .min(1, { message: "Name is required" });
